import React from 'react';
import PropTypes from 'prop-types';
import MainNavCardLinkComponent from './FsMainNavCardLink.styles.js';
import { LinkWrapper } from './FsMainNavCardLink.styles.js';
import { withSitecoreContext, mediaApi } from '@sitecore-jss/sitecore-jss-react';
import Link from '../../../shared/Link/Link';
import Icon from "../../../shared/Icon/Icon.jsx";

const FsMainNavCardLink = ({ text, src, ...props }) => {
  const imageUrl = mediaApi.updateImageUrl(src, { mw: 800, mh: 800 });
  return (
    <MainNavCardLinkComponent {...props}>
      <Link path={`${props.path}${props.query ? props.query : ''}`}>
        <LinkWrapper>
          <div className="image">
            <img className="card-image" src={imageUrl} alt={`view ${text} page`}/>
            <div className="view">View</div>
          </div>
          <div className="card-label">
            {text}
            <span className="circle"><Icon icon="chevron-right" size="small"/></span>
          </div>
        </LinkWrapper>
      </Link>
    </MainNavCardLinkComponent>
  );
};

FsMainNavCardLink.propTypes = {
  text: PropTypes.string,
  src: PropTypes.string,
};

export default withSitecoreContext()(FsMainNavCardLink);